import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import messages from '../../messages';
import { toast } from 'react-toastify';
import AddToCartButton from '../cart/AddToCartButton';
import { getProductSpecification } from '../../redux/actions/productActions';
import { Modal, Image, Container, Row, Col } from 'react-bootstrap';

import CurrencyFormat from '../other/CurrencyFormat';
import ModalLoyalty from '../other/ModalLoyalty';
import LoyaltyFinishModalSpecialAction from '../../components/modal/LoyaltyFinishModalSpecialAction';

import MessageInfoBox from '../../components/other/MessageInfoBox';
import { useTranslation } from 'react-i18next';
import LoyaltyJokerResultModal from '../modal/LoyaltyJokerResultModal';


const LoyaltySpecialItem = ({ item, loyaltySettings, isClickedSpecialItem, getUserInfo, shopIsActive, keyItem, mainItem, finishCart, setFinishCartFunction, setEmptyValues, emptyValues, isConditionReached, handleCancelButtonClick, itemKey, clickedSpecialItems, setShouldAnimate, cardBg, cardBgColor, cardAspect, soldOutSpecial, soldOutPremium, openCardDarkText, isDeal, tier }) => {
    // Modal potvrde kupovine (LoyaltyJokerResultModal, ishod "confirmed") je dizajniran za sva 3
    // nivoa. 'tier' dolazi kao 'Deal'/'Super'/'Premium' (TIER_NAMES).
    // NAPOMENA: ishod "canceled" (Odustani) se NE prikazuje ovde vise - vidi handleCancelButtonClick
    // u LoyaltyShopPage.js. Klik na Odustani odmah setuje canceledItems (parent state), sto ovde
    // (u LoyaltySpecialConditionGroup.js) obara isItemOpen na false za Deal/Super (nisu alwaysOpen),
    // sto UNMOUNT-uje BAS OVU komponentu - bilo kakvo lokalno state ovde ("prikazi canceled modal")
    // bi nestalo tacno u trenutku kad treba da se prikaze (zivo potvrdjeno - modal se nikad nije
    // pojavio). "confirmed" ovo NE pogadja - uspesna kupovina POPUNI confirmedPurchases (ne brise
    // ga), pa isItemOpen ostaje true i komponenta ostaje mount-ovana.
    const tierKey = tier ? tier.toLowerCase() : null;
    const hasConfirmedResultModal = tierKey === 'deal' || tierKey === 'super' || tierKey === 'premium';
    // null = ne prikazuj nista, 'confirmed' = prikazi taj ishod (jedini koji ovde ikad moze da se desi).
    const [jokerResultVariant, setJokerResultVariant] = useState(null);
    // Reload (osvezavanje stanja sa servera) se namerno odlaze do zatvaranja modala (ranije se
    // desavao ODMAH nakon slanja mail-a, sto bi odmah ugasilo tek prikazan modal).
    const handleCloseJokerResultModal = () => {
        const wasConfirmed = jokerResultVariant === 'confirmed';
        setJokerResultVariant(null);
        if (wasConfirmed) {
            window.location.reload();
        }
    };
    // Glavna kapija: isItem je true SAMO ako item.anPrice ima pravu vrednost.
    // Ako je false, cela komponenta ne prikazuje NISTA (vidi {isItem && ...} na liniji 237).
    // anPrice moze biti prazno npr. ako je artikal stigao kao goli broj preko REST-a (nema nijedno
    // polje), ili je stigao pun preko socketa ali Condition jos nije dostignut (anPrice je null).
    const isItem = item ? (item.anPrice ? true : false) : false;
    // console.log('[DEBUG canClick:1] LoyaltySpecialItem item:', item, 'anPrice:', item?.anPrice, 'acBuyer:', item?.acBuyer, 'isItem:', isItem);

    const dispatch = useDispatch();
    var percentProduct = 0;
    if (item && item.anPrice && item.anOldPrice) {
        percentProduct = 100 - (parseFloat(item.anPrice) * 100 / parseFloat(item.anOldPrice));
    }
    const [show, setShow] = useState(false);
    const [qtyValue, setQtyValue] = useState('');
    const { t } = useTranslation('loyalty');
    const [showPopup, setShowPopup] = useState(false);

    // ime kupca ako je artikal vec prodat, inace prazan string (koristi se dalje kao "da li je prodato")
    const acBuyer = item && item.acBuyer && item.acBuyer ? item.acBuyer : "";

    // const [finishCart, setFinishCart = useState(false);

    const now = Date.now();
    const adLoyaltyStartDate = Date.parse(loyaltySettings.adLoyaltyStartDate)
    const adLoyaltyEndDate = Date.parse(loyaltySettings.adLoyaltyEndDate)
    const loyaltyTypeId = (loyaltySettings.anLoyaltyTypeId);
    // onemogucava klik na ime proizvoda (link ka specifikaciji) ako je Condition dostignut I artikal
    // je vec nekome prodat - nema smisla gledati specifikaciju rasprodatog bonus artikla
    const isLinkDisabled = isConditionReached && acBuyer !== ""; //disejblovanje linka ako je onemogucena kupovina iz bilo kog razloga
    // const dummyNow = new Date(2022, 9, 26, 11, 23);
    // const parsedDummyDate = Date.parse(dummyNow)

    const handleShow = () => { //modal za specifikaciju        
        setShow(true);
        dispatch(getProductSpecification(item.anProductKey));
    }

    const handleShowPopup = (event) => { //modal za kupovinu
        // event.preventDefault();
        setShowPopup(true);
    }

    const handleCloseLoyaltyModal = () => setShow(false); //zatvaranje modala za specifikaciju    

    const handleClose = () => setShowPopup(false); //zatvaranje modala za kupovinu

    // Bira sta prikazati umesto cene - zavisi od shopIsActive (aktivnost CELE stranice, ne ovog
    // Condition-a). Tri moguca ishoda: shop nije aktivan ali cena je vidljiva -> ipak prikazi cenu;
    // shop je aktivan -> prikazi cenu; nijedno od ova dva -> prikazi tekst "uskoro".
    const renderElement = () => {

        if (shopIsActive == 0 && item.isPriceVisible == 1) {
            return (
                <>
                    <div className="special-product-price">
                        <span className="loyaltyOldPriceSpecial"><CurrencyFormat num={item.anOldPrice} /> {t('EUR')}</span>
                        <span className=""><CurrencyFormat num={item.anPrice} /> {t('EUR')}</span>

                    </div>
                    {/* <div className="percetange-loyatly-special-product">{parseInt(percentProduct)}<small>%</small></div> */}
                </>
            )
        } else if (shopIsActive == 1) {
            return (
                <>
                    <div className="special-product-price">
                        <span className="loyaltyOldPriceSpecial"><CurrencyFormat num={item.anOldPrice} /> {t('EUR')}</span>
                        <span className=""><CurrencyFormat num={item.anPrice} /> {t('EUR')}</span>

                    </div>
                    {/* <div className="percetange-loyatly-special-product">{parseInt(percentProduct)}<small>%</small></div> */}
                </>
            )
        } else {
            return (
                <>
                    <div className="t">{t('uskoro')}</div>
                    <div></div>
                </>
            )
        }
    };

    // MRTAV KOD - ova funkcija se nigde ne poziva. Koristila bi je renderInputElement/
    // renderInputElementTehnovacije, ali su obe zakomentarisane nize (linije ~170-223).
    const setQtyValueFunction = (name, val) => {

        if (val == "0" || (!isNumeric(val) && val != "")) {
            val = ""
            setQtyValue('');
            toast(<MessageInfoBox message="loyaltyNoZeroQty" type="0" />, {
                className: 'red-background',
            });
        } else {
            if (item.anQty < item.anQtyAvailableForCompany) {
                if (parseInt(val) > item.anQty) {
                    setQtyValue(item.anQty);
                    toast(<MessageInfoBox message="loyaltyLimitQty" type="0" />, {
                        className: 'red-background',
                    });
                } else {
                    setQtyValue(val);
                }
            } else {
                if (parseInt(val) > item.anQtyAvailableForCompany) {
                    setQtyValue(item.anQtyAvailableForCompany);
                    toast(<MessageInfoBox message="loyaltyLimitQty" type="0" />, {
                        className: 'red-background',
                    });
                } else {
                    setQtyValue(val);
                }
            }

            // if (parseInt(val) > item.anQty) {
            //     if (parseInt(val) > item.anQtyAvailableForCompany) {
            //         if (item.anQty <= item.anQtyAvailableForCompany) {

            //         }
            //         setQtyValue(item.anQtyAvailableForCompany);
            //         toast(<MessageInfoBox message="loyaltyLimitQty" type="0" />, {
            //             className: 'red-background',
            //         });
            //     } else {
            //         setQtyValue(item.anQty);
            //         toast(<MessageInfoBox message="loyaltyLimitQty" type="0" />, {
            //             className: 'red-background',
            //         });
            //     }
            // } else {
            //     setQtyValue(val);
            // }

            // if (parseInt(val) > item.anQtyAvailableForCompany) {
            //         setQtyValue(item.anQtyAvailableForCompany);
            //         toast(<MessageInfoBox message="loyaltyLimitQty" type="0" />, {
            //             className: 'red-background',
            //         });

            // } else {
            //     setQtyValue(val);
            // }
        }

        if (val == "") {
            let filteredArray = emptyValues.filter((item, index) => item.name !== name);
            setEmptyValues(filteredArray)
        } else {
            setEmptyValues([...emptyValues, { "name": name, "value": val }])
        }

    }

    function isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the entirety of the string (`parseFloat` alone does not do this)...
            !isNaN(parseInt(str)) // ...and ensure strings of whitespace fail
    }
    //  const blockInvalidChar = e => ['e', 'E', '+', '-', '0'].includes(e.key) && e.preventDefault();

    useEffect(() => {
        setQtyValue('');
    }, [finishCart])
    // const renderInputElement = () => {
    //     if (shopIsActive == 1 && getUserInfo.acCompanyLoyaltyStatus.trim().toUpperCase() != 'CRVEN' && loyaltySettings.anCompanyTarget < loyaltySettings.anCompanyTargetAchieved && (adLoyaltyStartDate <= now && adLoyaltyEndDate >= now)) {
    //         if (item.anQtyAvailableForCompany > 0) {
    //             return (
    //                 <input
    //                     type="text"
    //                     className="form-control loyalty-input-value"
    //                     data-product={item.anProductKey}
    //                     data-product-name={item.acProductName}
    //                     data-product-price={item.anPrice}
    //                     data-product-ident={item.acProduct}
    //                     data-product-id={item.anProductId}
    //                     value={qtyValue}
    //                     // onKeyDown={blockInvalidChar}
    //                     onChange={(e) => setQtyValueFunction(item.acProduct, e.target.value)}
    //                     disabled={item.anQty <= 0 || item.anQtyAvailableForCompany <= 0 && true}
    //                 />
    //             )
    //         } else {
    //             return null;
    //         }

    //     } else {
    //         return null;
    //     }


    // }
    // const renderInputElementTehnovacije = () => {
    //     if (shopIsActive == 1) {
    //         if (item.anQtyAvailableForCompany > 0) {
    //             return (
    //                 <input
    //                     type="text"
    //                     className="form-control loyalty-input-value"
    //                     data-product={item.anProductKey}
    //                     data-product-name={item.acProductName}
    //                     data-product-price={item.anPrice}
    //                     data-product-ident={item.acProduct}
    //                     data-product-id={item.anProductId}
    //                     value={qtyValue}
    //                     // onKeyDown={blockInvalidChar}
    //                     onChange={(e) => setQtyValueFunction(item.acProduct, e.target.value)}
    //                     disabled={item.anQty <= 0 || item.anQtyAvailableForCompany <= 0 && true}
    //                 />
    //             )
    //         } else {
    //             return null;
    //         }

    //     } else {
    //         return null;
    //     }
    // }
    const renderButtonSubmitLoyalty = () => {
        // if (getUserInfo.acCompanyLoyaltyStatus && (getUserInfo.acCompanyLoyaltyStatus.trim().toUpperCase() != 'CRVEN' && loyaltySettings.anCompanyTarget < loyaltySettings.anCompanyTargetAchieved)) {

        return (
            <div className={`${emptyValues.length == 0 || emptyValues.filter(i => i.value == 0).length > 0 ? "button-submit-ly-shop-disabled" : ""} button-submit-ly-shop`}>
                <button type="submit" className="btn-sm btn w-100 btn-success add-special-product-btn" onClick={(e) => handleShowPopup()} ><i className="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp; Kupi</button>
            </div>
        );
        // }
    };

    return (
        <>
            {/* cela kartica se renderuje samo ako isItem - vidi komentar na liniji 19 */}
            {isItem &&
                // <div className={`${keyItem === 0 ? 'table-row-no-padding-top' : ''} loyalty-special-open-product-holder ${((isSpecialOpen === 1 || isSpecialOpen === 2) && acBuyer !== "") ? 'sold-out' : ''} ${clickedSpecialItem === keyItem ? 'flip' : ''}`} key={keyItem}>
                <div
                    className={`${keyItem === 0 ? 'table-row-no-padding-top' : ''} loyalty-special-open-product-holder ${(isConditionReached && acBuyer !== "") ? 'sold-out' : ''} ${openCardDarkText ? 'special-open-dark-text' : ''} ${isDeal ? 'special-open-deal' : ''}`}
                    key={keyItem}
                    style={(cardBg || cardBgColor || cardAspect) ? {
                        // cardBg (slika) ILI cardBgColor (obicna boja, npr. bela za Super - slika
                        // special-white-card.png je imala DRUGACIJU proporciju od super-card.png
                        // ("?" kartice), pa je ostavljala providan razmak sa strane; obicna boja
                        // automatski prati TACNO istu velicinu kontejnera kao "?" kartica).
                        ...(cardBg ? {
                            backgroundImage: `url(${cardBg})`,
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundColor: 'transparent',
                            backgroundRepeat: 'no-repeat',
                        } : cardBgColor ? { backgroundColor: cardBgColor, borderRadius: '16px' } : {}),
                        // .loyalty-special-open-product-holder je inace fiksno 250x250 (index.css) -
                        // za kartice sa svojom pozadinom (slika ili boja) prekriva CEO roditelja
                        // (.special-flip-holder, sad ima definisanu visinu preko padding-bottom%
                        // trika u LoyaltySpecialConditionGroup.js) umesto da racuna sopstveni
                        // aspect-ratio - taj trik je pravio kolaps visine u CSS Grid-u. Vezano SAMO za
                        // cardAspect (ne za cardBg/cardBgColor) - Deal na mobilnom takodje dobija
                        // cardAspect (portret razmera '199/267'), pa i njemu treba ovo poravnanje da bi
                        // otvorena kartica pratila TACNU visinu zatvorene "?" kartice (koja na mobilnom
                        // vise ne koristi fiksnih 234x234 iz .special-open-deal, vec racuna sirinu/
                        // visinu iz cardHolderStyle) - bez ovoga otvorena Deal kartica na mobilnom
                        // ostaje na fiksnih 250x250/234x234 dok se zatvorena kartica menja po ekranu.
                        ...(cardAspect ? { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } : {}),
                    } : undefined}
                >
                    {/* Dekorativni okvir (ikonica + isprekidana linija + uglovi) na beloj pozadini -
                        isti motiv kao na "?" kartici (deal/super-card.png), samo iscrtan preko CSS-a
                        umesto da bude deo slike, pošto ova kartica koristi cardBgColor (obicnu boju),
                        ne sliku. */}
                    {cardBgColor && (
                        <div className="special-open-card-decor">
                            <div className="special-open-card-decor-icon"><img src={`${process.env.PUBLIC_URL}/images/loyalty/premium-icon-card.png`} alt="" /></div>
                            <div className="special-open-card-decor-corner special-open-card-decor-corner-tr"></div>
                            <div className="special-open-card-decor-dots special-open-card-decor-dots-top"></div>
                        </div>
                    )}
                    {/* "Vise nije u igri" bedz - Condition dostignut I neko je vec kupio bas ovaj artikal.
                        Isti tekst za sva 3 nivoa (Deal ranije imao "Rasprodato", po dizajnu vise ne). */}
                    {isConditionReached && acBuyer !== "" && (
                        <div className={`sold-text ${soldOutSpecial ? 'sold-text-special' : ''} ${soldOutPremium ? 'sold-text-premium' : ''}`}>{t('viseNijeUIgri')}</div>
                    )}


                    <div className="percetange-loyatly-special-product" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/loyalty/discount.png)` }}>{parseInt(percentProduct)}<small>%</small></div>
                    <div>
                        <div className="open-product-special-img">
                            <img src={`https://resource.ewe.rs/products/${item.acProduct}_v.jpg`} alt="" className="img-fluid img-loyalty-product" />
                        </div>
                    </div>
                    {/* <div>{item.acProduct}</div> */}
                    <div>
                        {item.isSpecialForCompany == 1 && (
                            <img src="/images/loyalty/special-for-company.png" className="special-icon-loyalty-for-company" alt="Loyalty Shop" />
                        )}
                        {item.isSaleConnected == 1 && (
                            <img className="smallBadge" src="/images/loyalty/badges-povezana-prodaja.png" />
                        )}
                        {item.acConditionType == 'PovezanaProdaja' && (
                            <img className="smallBadge" src="/images/loyalty/badges-povezana-prodaja-artikal.png" />
                        )}
                    </div>
                    <div className="special-name-prices-holder">
                        <div className={`loyalty-detail-name-click special-product-name-click ${isLinkDisabled ? 'disabled-link' : ''}`} onClick={isLinkDisabled ? null : (e) => handleShow()}>
                            {item.acProductName}
                        </div>
                        {/* <div className="text-align-right">{shopIsActive == 1 ? item.anQty : item.anQtyVirtual}</div> */}

                        {renderElement()}
                    </div>
                    {/* <div className="">
                    <span className="loyaltyOldPriceSpecial"><CurrencyFormat num={item.anOldPrice} /> <small>{t('EUR')}</small></span>s
                </div> */}

                    {/* <div>
                {loyaltyTypeId == 1 ? renderInputElement() : loyaltyTypeId == 2 ? renderInputElementTehnovacije() : null}
            </div> */}

                    {/* Dugmad na dnu - tri moguca ishoda:
                        1) vec prodato -> prikazi "Kupio [ime]"
                        2) bas OVAJ korisnik je upravo kupio (isClickedSpecialItem), a jos nije oznaceno
                           kao prodato -> prikazi "Odustani" + "Dodaj u korpu" dugmad
                        3) nijedno -> ne prikazuj nista */}
                    <div className={`special-product-button ${(cardBg || cardBgColor) ? 'special-product-button-stacked' : ''}`}>
                        {
                            isConditionReached && acBuyer !== "" ? (
                                <div className="bought-2">
                                    <i class="fas fa-exclamation"></i>
                                    Kupio <span>{acBuyer}</span>
                                </div>
                            ) : isClickedSpecialItem && acBuyer === "" ? (
                                <>
                                    <div>
                                        {/* <button id={itemKey} className="cancelButton btn btn-sm btn-call w-100" onClick={() => handleCancelButtonClick(itemKey)}> */}
                                        <button id={itemKey} className="cancelButton btn btn-sm btn-call w-100" onClick={() => { handleCancelButtonClick(itemKey, tier); }}>
                                            <i className="fas fa-ban" aria-hidden="true"></i>&nbsp; {t('odustani')}
                                        </button>
                                    </div>
                                    <div className="add-special-product addSpecialItemToCart text-center">
                                        {renderButtonSubmitLoyalty()}
                                    </div>
                                </>
                            ) : null
                        }
                    </div>


                    <ModalLoyalty show={show} item={item} handleClose={handleCloseLoyaltyModal} />

                    <Modal
                        show={showPopup}
                        onHide={handleClose}
                        keyboard={false}
                        dialogClassName='modal-xl loyalty-confirm-modal'
                        aria-labelledby=""
                        centered
                    >
                        <div className="close-action-modal" variant="secondary" onClick={handleClose}>
                            <i className="far fa-times-circle"></i>
                        </div>
                        <Modal.Header>
                            <h4>{t('potvrdaKupovine')}</h4>
                        </Modal.Header>
                        <Modal.Body>
                            <LoyaltyFinishModalSpecialAction acProduct={item.acProduct} anQty={item.anQty} anProductKey={item.anProductKey} anProductId={item.anProductId} acProductName={item.acProductName} anPrice={item.anPrice} setFinishCartFunction={finishCart} finishCart={finishCart} handleClose={handleClose} setEmptyValues={setEmptyValues} type={1} start={loyaltySettings.adLoyaltyStartDate} end={loyaltySettings.adLoyaltyEndDate} onPurchaseConfirmed={hasConfirmedResultModal ? () => setJokerResultVariant('confirmed') : undefined} />

                            {/* <LoyaltyFinishModalSpecialAction setFinishCartFunction={setFinishCart} finishCart={finishCart} handleClose={handleClose} setEmptyValues={setEmptyValues} type={1} start={loyaltySettings.adLoyaltyStartDate} end={loyaltySettings.adLoyaltyEndDate} /> */}
                        </Modal.Body>
                    </Modal>

                    <LoyaltyJokerResultModal
                        show={!!jokerResultVariant}
                        onClose={handleCloseJokerResultModal}
                        tier={tier}
                        variant={jokerResultVariant}
                    />
                </div >
            }
        </>
    );
};

export default LoyaltySpecialItem;